/**
 * @see https://github.com/referenceable/referenceable_api/blob/develop/app/graphql/application/types/signables/signable_provider_enum_type.rb
 */
export enum SignableProviders {
  DocuSign = 'docusign',
  EnableUs = 'enableus',
}
